<template>
  <section class="section mobile_div section_bg  custom_page_v2 first_page ">
    <loading-block v-if="is_load==false" :loading="!is_load"/>
    <div class="section_header mobile_div  d-flex justify-content-center" v-if="is_load">
    <nav aria-label="breadcrumb" v-if="is_load" >
      <ol class="breadcrumb">
        <li class="breadcrumb-item"><router-link tag="a" :to="{name: 'project',params:{'id':project.last_id}}">
          {{ project.name_project}}
        </router-link></li>
        <li class="breadcrumb-item"><router-link tag="a" :to="{name: 'list_articles',params:{'id':project.last_id}}">
          База знаний
        </router-link></li>
        <li class="breadcrumb-item active" aria-current="page">Редактировать статью</li>
      </ol>
    </nav>
    </div>
    <div v-if="is_load" class=""  >


      <div class="" v-if="is_load">
        <div class="section_header nocenter mobile_div">
          <h4 class="text-center">Редактировать</h4>
          <div class="container-fluid">

            <div class="form-group row">
              <div class="col-12 col-md-4">
                Категория
              </div>

              <div class="col-12 col-md-8">
                <select class="form-control" v-model="newPost.parent_id">
                  <option v-if="options.length>0"  v-for="option in options"
                      :key="option.parent_id" :value="option.parent_id">{{ option.title}}</option>
                </select>
              </div>

            </div>

            <editorjsinput :blocks_json="newPost.content.blocks" ref="editorjs" ></editorjsinput>


            <div class="alert alert-danger" v-if="iserror==true">
              <p>{{ error_message }}</p>
            </div>
            <base-button  @click="onSaveWork" >Сохранить запись</base-button>
          </div>
        </div>

      </div>
    </div>
  </section>
</template>

<script>
import Api from "@/models/Api";
import Editorjsinput from "@/models/Editorjsinput";
import LoadingBlock from "@/components/Custom/LoadingBlock";

export default {
  name: "AddPost",
  data() {

    var app = this;

    return {
      'work_id':null,
      'newPost':{


        "parent_id":"",

      },
      'options':[],
      'example_blocks':[
        {
          "type": "header",
          "data": {
            "text": "Название записи",
            "level": 2
          }
        },

        {
          "type": "paragraph",
          "data": {
            "text": "Здесь какое то описание",
          }
        },

      ],
      'is_load':false,
      'categorys':[],
      'iserror':false,
      'error_message':'',
      'project':null,




    }
  },
  mounted: function () {
    var app = this;

    // let id = app.$route.params.id;


    var id=app.$route.params.id;
    var post_id=app.$route.params.post_id;
    Api.loadArticleOne(id,post_id, '',function (data) {
      app.newPost = data.post;
      app.project=data.project;
      Api.loadArticleOptions(id,function(data_option){
        app.options=data_option.options;
        app.is_load=true;
      })

    })







  },components: {
    'editorjsinput': Editorjsinput,LoadingBlock
  },methods:{

    onSaveWork(){
      var app=this;
      app.$refs.editorjs.save(function(editor_js_data){

        var newPost=app.newPost;

        newPost['json']=editor_js_data;

        Api.createArticle(app.project.last_id,newPost, function (result) {
          if (result.iserror == false) {
            app.iserror = false;

           // document.location = "/project/"+app.project.last_id+"/articles/" + result.post_id+"/";
            app.$router.push({name: 'one_article',params: {id: app.project.last_id, "post_id":result.post_id}});

          } else {
            app.iserror = true;
            app.error_message = result.error_message;
          }
        });



      });
    },


  },
}
</script>

<style scoped>

</style>